import { SKILL_GROUPS } from '../data/skills';

const SEQ = [];
SKILL_GROUPS.forEach((g, gi) => {
  g.skills.forEach((s) => SEQ.push({ text: s, bar: false }));
  if (gi < SKILL_GROUPS.length - 1) SEQ.push({ bar: true });
});

function Run() {
  return (
    <div className="flex items-center">
      {SEQ.map((item, i) =>
        item.bar ? (
          <span key={i} className="mx-7 w-[3px] h-4 shrink-0 accent-gradient rounded-full" aria-hidden="true" />
        ) : (
          <span key={i} className="flex items-center gap-7">
            <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-slate-400 whitespace-nowrap">
              {item.text}
            </span>
            <span className="w-1 h-1 rounded-full accent-gradient shrink-0" aria-hidden="true" />
          </span>
        )
      )}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="relative overflow-hidden border-y border-white/[0.06] py-6 bg-deep/40" data-testid="skills-marquee">
      <div className="flex w-max animate-marquee" style={{ animationDuration: '90s' }}>
        <div className="flex">
          <Run />
        </div>
        <div className="flex" aria-hidden="true">
          <Run />
        </div>
      </div>
    </div>
  );
}
